import React from 'react';
import { useTranslation } from 'react-i18next';

import titleImg from '../../../asset/img/edocument_linktodata_title_img.svg';

import SubTitleSection from '../../../components/SubTitleSection';
import Typography from '../../../components/common/Typography';
import Button from '../../../components/common/Button';

const Step1 = ({ stepHandler }) => {
  const { t } = useTranslation('eDocuments');

  return (
    <div>
      <SubTitleSection title={t('linkToData.step1.title')} img={titleImg} />
      <div className="step1InfoContainer">
        <div className="backgroundBox"></div>
        <Typography variant="body1Bold">{t('linkToData.step1.info.title')}</Typography>
        <Typography variant="body2Medium">{t('linkToData.step1.info.description')}</Typography>
      </div>

      <div className="stepButtonContainer">
        <Button value={t('linkToData.step1.button')} fullWidth onClick={() => stepHandler(2)} />
      </div>
    </div>
  );
};

export default Step1;
